import { useEffect, useRef } from 'react';
import { CLOUDSCAPE_MOBILE_BREAKPOINT } from '../utils/constants';

/**
 * Matches Cloudscape AppLayout at the mobile breakpoint: close the drawer when
 * the viewport becomes narrow, and reopen it when the viewport becomes desktop
 * again. Link taps also close it while mobile; this covers a live resize.
 */
export const useRestoreSideNavOnDesktop = (enabled: boolean, setIsSideNavOpen: (open: boolean) => void) => {
    const wasMobileRef = useRef(false);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        const mediaQuery = window.matchMedia(`(max-width: ${CLOUDSCAPE_MOBILE_BREAKPOINT}px)`);

        const handleChange = () => {
            const isMobile = mediaQuery.matches;
            if (isMobile && !wasMobileRef.current) {
                setIsSideNavOpen(false);
            } else if (wasMobileRef.current && !isMobile) {
                setIsSideNavOpen(true);
            }
            wasMobileRef.current = isMobile;
        };

        wasMobileRef.current = mediaQuery.matches;
        mediaQuery.addEventListener('change', handleChange);

        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, [enabled, setIsSideNavOpen]);
};
